import React from "react"
import { Flex } from "@chakra-ui/react"
import CopyToClipboard from "components/elements/CopyToClipboard"
import Link from "components/elements/Link"
import Button from "components/Buttons/Button"

type Props = {
  url?: string
}

const UrlRow = ({ url }: Props) => {
  if (!url) {
    return null
  }

  return (
    <Flex justifyContent="space-between">
      <Link href={url} isExternal>{url}</Link>
      <Flex gap={2}>
        <CopyToClipboard text={url} size="xs" variant="outline">
          Copy
        </CopyToClipboard>
        <Button as="a" target="_blank" href={url} size="xs" variant="outline" leftIcon="link">
          View
        </Button>
      </Flex>
    </Flex>
  )
}

export default UrlRow
